import type { ChangeRequired } from '../Login.type';

function isFailedAuthResult(value: unknown): value is Omit<ChangeRequired, 'type'> {
  return (
    value !== null &&
    typeof value === 'object' &&
    'email' in value &&
    'session' in value &&
    typeof value.session === 'string' &&
    typeof value.email === 'string'
  );
}

export { isFailedAuthResult };
